import Vue from '../../vue';
import router from '../../router';
import { Debouncer, objectToHash, hashToObject, propToFnc } from '../../libraries/common';
import { merge } from 'lodash';

const parseUrlLocation = () => hashToObject(router.currentRoute.hash);

let dataFnc;
const updateLocation = () => {
  const defaults = {
    offset: Math.round(window.pageYOffset),
  };

  const urlParams = merge(parseUrlLocation(), defaults, dataFnc());

  var url = new URL(window.location.href);
  url.hash = objectToHash(urlParams);
  window.location.replace(url);
}

const debouncer = new Debouncer(100);
const debounceUpdateLocation = () => debouncer.clear().push(() => updateLocation({}));

Vue.directive('restore-scroll', {
  inserted: (el, binding) => {
    const { data, fnc } = binding.value;
    dataFnc = propToFnc(data);

    const params = parseUrlLocation();

    if (params && fnc) {
      var response = fnc(params);
      if (response?.then) {
        response.then(() => window.scrollTo(0, params.offset));
      } else {
        console.error('You need to return promise for restore-scroll to work!');
      }
    }

    window.addEventListener('scroll', debounceUpdateLocation);
  },
  unbind: () => {
    dataFnc = null;
    window.removeEventListener('scroll', debounceUpdateLocation);
  },
});